import React, { useState, useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import { Modal, Collapse } from "react-bootstrap";
import PsContext from "../../../context/PsContext";
import CategoriesMenu from "./categoriesMenu";
import MobSaree from "../topmenu/MobSaree";
import LehangaMob from "../topmenu/LehangaMob";

const MobileMenuModal = (props) => {
  const context = useContext(PsContext);
  const [showId, setShowId] = useState(null);

  const handleShowClick = (id) => {
    if (showId == id) {
      setShowId(null);
    } else {
      setShowId(id);
    }
  };

  const handleMenuClick = () => {
    props.onCancel();
  };

  return (
    <div
      className="canvas-wrapper mob-canvas shadow mt-2"
      style={{ fontSize: "14px" }}
    >
      <header
        className="canvas-headertf-md-hidden shadow mob-head shadow-0 mb-3"
        style={{ padding: "10px 15px", borderBottom: "1px solid #ddd" }}
      >
        <div className="filter-icon d-flex justify-content-between align-items-center mob-icon">
          <div>
            <a
              className="fs-13 text-primary text-uppercase"
              style={{
                fontWeight: "700",
                cursor: "pointer",
                fontSize: "13px",
                zIndex: "1000",
              }}
              onClick={props.onCancel}
            >
              <i
                className="fa fa-close text-dark"
                style={{ fontSize: "24px" }}
              ></i>
            </a>
          </div>
        </div>
      </header>

      <div className="canvas-body shadow mob-body px-3 pb-4">
        <ul className="menu metismenu" id="menu">
          <Link
            className="nav-item nav-link"
            to="/"
            onClick={() => handleMenuClick()}
          >
            HOME
          </Link>

          <li>
            <a className="has-arrow" onClick={() => handleShowClick("saree")}>
              SAREE <i className="fa fa-chevron-down ms-2"></i>
            </a>
            <Collapse in={showId == "saree"}>
              <ul>
                <MobSaree menuClick={handleMenuClick} />
              </ul>
            </Collapse>
          </li>

          <li>
            <a className="has-arrow" onClick={() => handleShowClick("lehenga")}>
              Lehanga <i className="fa fa-chevron-down ms-2"></i>
            </a>
            <Collapse in={showId == "lehenga"}>
              <ul>
                <LehangaMob menuClick={handleMenuClick} />
              </ul>
            </Collapse>
          </li>

          <li>
            <a
              className="has-arrow"
              onClick={() => handleShowClick("category")}
            >
              OTHERS <i className="fa fa-chevron-down ms-2"></i>
            </a>
            <Collapse in={showId == "category"}>
              <ul>
                <CategoriesMenu menuClick={handleMenuClick} />
              </ul>
            </Collapse>
          </li>

          <Link
            className="nav-item nav-link"
            to="/new-arraivals"
            onClick={() => handleMenuClick()}
          >
            NEW ARRIVAL
          </Link>
          <Link
            className="nav-item nav-link"
            to="/offers"
            onClick={() => handleMenuClick()}
          >
            OFFERS <span className="badge badge-success">new</span>
          </Link>
          {/* 
          <hr />
          {context.state.userLogged == "yes" ? (
            <a
              href="javascript:;"
              className="nav-item nav-link nav-link-sm has-icon text-black"
              onClick={() => {
                context.userLogout();
                props.afterLogout();
              }}
            >
              SIGN OUT
            </a>
          ) : (
            <a
              href="javascript:;"
              className="nav-item  nav-link nav-link-sm has-icon  text-black"
              onClick={(e) => props.afterFinish()}
            >
              SIGN IN / SIGN UP
            </a>
          )} */}
        </ul>
      </div>
    </div>
  );
};

export default MobileMenuModal;
